import React from 'react';
import { Link } from 'react-router-dom';

interface ToolCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  to: string;
  color: string;
}

const ToolCard: React.FC<ToolCardProps> = ({ title, description, icon, to, color }) => {
  return (
    <Link 
      to={to}
      className={`block p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 ${color} text-white`}
    >
      <div className="flex flex-col items-center text-center">
        <div className="p-3 rounded-full bg-white bg-opacity-20 mb-4">
          {icon}
        </div>
        <h3 className="text-xl font-bold mb-2">{title}</h3>
        <p className="opacity-90">{description}</p>
      </div>
    </Link>
  );
};

const PlanlamaPanel: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">Planlama Paneli</h1>
        <p className="text-gray-600">Tüm planlama araçlarına buradan erişebilirsiniz.</p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* Üretim Planlaması */}
        <ToolCard
          title="Üretim Planlaması"
          description="Üretim süreçleri ve iş akışı planlaması"
          to="/planlama/uretim"
          color="bg-gradient-to-br from-red-500 to-rose-600"
          icon={
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
          }
        />
        
        {/* Malzeme İhtiyaç Planı */}
        <ToolCard
          title="Malzeme İhtiyaç Planı"
          description="Malzeme ve kaynak planlama yönetimi"
          to="/planlama/malzeme"
          color="bg-gradient-to-br from-amber-500 to-orange-600"
          icon={
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
            </svg>
          }
        />
        
        {/* Kapasite Planlaması */}
        <ToolCard
          title="Kapasite Planlaması"
          description="Üretim kapasitesi ve verimlilik yönetimi"
          to="/planlama/kapasite"
          color="bg-gradient-to-br from-cyan-500 to-teal-600"
          icon={
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
          }
        />
      </div>
    </div>
  );
};

export default PlanlamaPanel;
